"use client";

import { useAction } from "@rangojs/router/client";
import { invalidateRevalidate, invalidateUpdate } from "../actions/cache-lab.js";

export function CacheLabButtons({ tag }: { tag: string }) {
  const { state: updateState } = useAction(invalidateUpdate);
  const { state: revalidateState } = useAction(invalidateRevalidate);

  return (
    <div className="flex flex-wrap gap-3">
      <form action={invalidateUpdate}>
        <input type="hidden" name="tag" value={tag} />
        <button
          type="submit"
          disabled={updateState === "loading"}
          className="rounded bg-slate-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-slate-800 disabled:opacity-50"
        >
          {updateState === "loading" ? "Purging…" : `updateTag("${tag}")`}
        </button>
      </form>

      <form action={invalidateRevalidate}>
        <input type="hidden" name="tag" value={tag} />
        <button
          type="submit"
          disabled={revalidateState === "loading"}
          className="rounded border border-slate-300 px-5 py-2.5 text-sm font-medium text-slate-800 hover:bg-slate-100 disabled:opacity-50"
        >
          {revalidateState === "loading" ? "Purging…" : `revalidateTag("${tag}")`}
        </button>
      </form>
    </div>
  );
}
